import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    // 登陆状态
    isLogin: false,
    crumbArr: [], // 面包屑导航栏的数据
    iframeUrl: '', // iframe的url
    permissionList: [],
    curMenu: {},
    level: localStorage.getItem('level'), // 用户权限等级
    foldMenu: localStorage.getItem('foldMenu') === 'false', // 折叠菜单栏
    resultIndex: 0,
    menusUpdate: 1, // 监听此值，更新菜单中数据管理下的列表
    userSocketStatus: 'offline', // 用户socket链接状态 online-已连接 offline-未连接
    templateHighRow: {}, // 设计模板列表行高亮
    templateSearch: {} // 设计模板筛选条件
  },
  mutations: {
    setPermissionList (state, arr) {
      state.permissionList = arr;
    },
    setUserSocketStatus (state, b) {
      if (b) {
        state.userSocketStatus = 'online';
      } else {
        state.userSocketStatus = 'offline';
      }
    },
    // 设置折叠菜单
    setFoldMenu (state, b) {
      state.foldMenu = b;
      localStorage.setItem('foldMenu', b);
    },
    // 保存当前菜单栏选项
    pushCurMenu (state, obj) {
      state.curMenu = obj;
    },
    // 更新等级
    setLevel (state, str) {
      state.level = str;
    },
    // 更新监听菜单
    setMenusUpdate (state) {
      state.menusUpdate++;
    },
    // 更新监听菜单
    SetTemplateHighRow (state, obj) {
      state.templateHighRow = obj;
    },
    // 模板筛选条件
    setTemplateSearch (state, obj) {
      state.templateSearch = obj;
    }
  },
  getters: {
  },
  actions: {
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js